export default __webpack_public_path__ + "static/210602_夏日活動強更預告_tc-fd2d681a9e58ace524ab25d908e1ffd1.webp";